










































































import { Vue, Component } from 'vue-property-decorator';
import { State, Getter } from 'vuex-class';
import { RootStoreState } from '@/store';
import { SwIconButton } from '@libs/unified-ui-framework/src/shared/sw-icon-button';
import { SwActionBar, SwActionBarItem } from '@libs/unified-ui-framework/src/shared/sw-action-bar';
import { AppConfig } from '../app-config-service';

@Component({
  components: {
    SwIconButton,
    SwActionBar,
    SwActionBarItem,
  },
})
export default class SwAppHeader extends Vue {
  bannerText: string = 'Security Center';

  showHelpIcon: boolean = false;

  @State((state: RootStoreState) => (state.CoreStoreModule.appConfig))
  appConfig: AppConfig;

  @Getter
  isAppConfigReady: boolean;

  onClickAction(config: AppConfig['helpConfig']) {
    window.open(config.url, config.target);
  }

  onClickBannerLogo() {
    window.open('https://www.sonicwall.com', '_blank');
  }

  onClickBannerText() {
    window.open('/', '_self');
  }
}
